import React, { Component } from 'react'; 
import GiftListSidebar from '../../components/GiftListSidebar';
import GiftListConfigureWapModal from '../GiftListConfigureWapModal';
import commonUtil from '../../../../../../utils/commonUtil';
import EventCardProfile from '../../../../../../components/EventTemplate/EventCardProfile';
class GiftListConfigureWap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // initialize your state here
            showModal: false
        };
    }


    handleConfigure = (e) => {
        e.preventDefault();
        this.setState({ showModal: true });
    }

    onItemClick = (id) => {
       this.setState({ showModal: false });
       this.props.onItemClick(id);
    }

    render() {
        return (
            <React.Fragment>
                {/* Your component content goes here */}
                <span className="icon-settings" onClick={(e) => this.handleConfigure(e)}></span>
                {this.state.showModal && (
                    <GiftListConfigureWapModal
                        headerClassName="evnt-modal-header-giftList"
                        titleClassName="evnt-modal-title-giftList"
                        closeIconClassName="evnt-modal-close-icon-giftList"
                        title="Configuración"
                        bodyClassName="evnt-modal-body-giftList event-modal-body-giftList-wap"
                        closeModal={() => this.setState({ showModal: false })}
                    >
                        <GiftListSidebar
                          initialJson={this.props.initialJson}
                          onItemClick={(id) => {this.onItemClick(id)}}
                          isactiveItem={this.props.isactiveItem}
                          giftAvailable={this.props.giftAvailable}
                          isAgent={this.props.isAgent}
                        iswap={true} />
                    </GiftListConfigureWapModal>
                )}                
            </React.Fragment>
        );
    }
}

export default GiftListConfigureWap;